import React, { Component } from 'react';
import { TitleCaseFormat } from '../shared/TitleCaseFormat';

export class PersonalInfoItem extends Component {
    render() {
        return (
            <div className="row margin-top-10">
                <div className="col-4 personalinfodata">{this.props.title}</div>
                <div className="col-8 personalinfodatatext">
                    <TitleCaseFormat>
                        {this.props.children}
                    </TitleCaseFormat>
                </div>
            </div>);
    }
}